import BaseModel from "./BaseModel";

/**
 * Pagination
 */
export default class Pagination extends BaseModel{
  constructor({
    data,
    total,
    per_page,
    current_page,
    last_page,
    from,
    to
  }) {
    super();

    this.data = data || null;
    this.total = total || null;
    this.per_page = per_page || null;
    this.current_page = current_page || null;
    this.last_page = last_page || null;
    this.from = from || null;
    this.to = to || null;
  }

  /**
   * Sets new value to this.data
   * Obs: Always sets an Array
   */
  setData(values = []) {
    this.data = Array.isArray(values) ? values : [];
  }
}
